import { render, staticRenderFns } from "./AllocatedTab.vue?vue&type=template&id=3e66df36&"
import script from "./AllocatedTab.vue?vue&type=script&lang=js&"
export * from "./AllocatedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports